// common event ids
export enum EventIds {
  Redirect = 'redirect',
  ServiceRender = 'service:render',
  ChangeLanguage = 'change:language',
  UserLogin = 'user:login',
  UserLogout = 'user:logout',
  RedirectUserBonuses = 'redirect:user-bonuses',
  ChangeCashierResultURL = 'change:cashier-result-url',
  ChangeNavigation = 'change:navigation',
  AmsSegments = 'ams:segments',
  ChangeUserBalance = 'change:user-balance',
  UpdateNavbarCallback = 'update:navbar:callback',
  ChangeLayoutDimensions = 'change:layout-dimensions',
}

// dynamic ids
export enum DynamicIds {
  ChangePageEventPrefix = 'change:page:',
  Unhandled = 'UNHANDLED_SHELL_EVENT',
}

// requests of modal ids
export enum RequestModalIds {
  Login = 'modal:login',
  Deposit = 'modal:deposit',
  ApplicationInstall = 'modal:application-install',
}

// requests of update ids
export enum RequestUpdateIds {
  Balance = 'balance',
}

// change interface ids
export enum ChangeInterfaceIds {
  Header = 'change:interface:header',
}

// update events
export enum UpdateEventIds {
  Navbar = 'update:navbar',
}
